import axios from '@axios'
import endpoints from './endpoints'

export default {
  getPaginado(page, pageSize, filtros) {
    return axios.post(endpoints.paged(page, pageSize), filtros)
  },

  getURL(id) {
    return axios.get(endpoints.url(id))
  },

  getObservacoes(id) {
    return axios.get(endpoints.observacoes(id))
  },

  removerObservacao(id) {
    return axios.delete(endpoints.removerObservacao(id))
  },

  salvarObservacao(observacao) {
    return axios.post(endpoints.salvarObservacao, observacao)
  },

  baixaEmLote(filtros, nomeArquivo) {
    return axios.post(endpoints.baixaLotes(nomeArquivo), filtros)
  },

  baixarEmExcel(tipo, filtros) {
    return axios.post(endpoints.baixaExcel(tipo), filtros)
  },

  getHistorico(tipo, id, filtros) {
    return axios.post(endpoints.historico(id), filtros)
  },

  notificaCcMei(id, payload) {
    return axios.post(endpoints.notifica(id), payload)
  },

  notificaHistorico(nomeEmpresa, emailEmpresa, emailCc, mensagemAdicional, definirEmailPadrao, ids) {
    return axios.post(endpoints.notificaHistorico(emailEmpresa, emailCc, nomeEmpresa, mensagemAdicional, definirEmailPadrao), Array.isArray(ids) ? ids : [ids])
  },

  verificarEmail(ids) {
    return axios.post(endpoints.verificarEmail, ids)
  },

  enviarEmLote(nome, filtroDocs) {
    return axios.post(endpoints.enviarEmail(nome), filtroDocs)
  },

  getDocWhatsapp(id) {
    return axios.get(endpoints.urlWhatsapp(id))
  },
}
